<ng-container [formGroup]="formGroup">

  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Directors</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="addDirector()">
        Add a Director
      </lds-button>
    </div>
  </div>

  <div formArrayName="directors">
    <ng-container *ngIf="form.controls.length > 0; else tplNoDirectors">
      <app-inline-item
        *ngFor="let directorForm of form.controls; let i = index"
        [form]="directorForm"
        [isExpandable]="true"
        [initiallyExpanded]="expandedIndex === i"
        (delete)="removeDirector(i)">
        <inline-summary>
          <div class="row">
            <div class="col-9">
              {{ directorForm.controls.director.value?.name ?? '-' }}
            </div>
          </div>
        </inline-summary>
        <inline-content>
          <div class="row" [formGroupName]="i">
            <div class="col-9">
              <app-contact-search formControlName="director" label="Director">
              </app-contact-search>
            </div>
          </div>
        </inline-content>
      </app-inline-item>
    </ng-container>
    <ng-template #tplNoDirectors>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      minlength: 'At least one director is required',
      required: 'At least one director is required'
    }">
  </lds-form-feedback>
</ng-container>
